import React from 'react';
import './WebDevelopment.css';

const WebDevelopment = () => {
  return (
    <div className="webdev-container">
      <div className="webdev-hero">
        <h1 className="webdev-title">Web Development Services</h1>
        <p className="webdev-subtitle">
          From landing pages to complex dashboards — we craft responsive, scalable, and lightning-fast websites tailored to your business needs.
        </p>
      </div>

      <div className="webdev-features">
        <div className="feature-card">
          <h3>Responsive by Default</h3>
          <p>Your site will look stunning on all devices — from mobile to desktop — without compromise.</p>
        </div>
        <div className="feature-card">
          <h3>Performance-First</h3>
          <p>We prioritize speed and optimization so your users enjoy a seamless, fast-loading experience.</p>
        </div>
        <div className="feature-card">
          <h3>Admin Dashboards</h3>
          <p>Custom admin panels built with React, Next.js, and APIs to help you manage your data efficiently.</p>
        </div>
        <div className="feature-card">
          <h3>API Integration</h3>
          <p>We connect your frontend to any API or backend service — Stripe, Firebase, Supabase, Node.js, and more.</p>
        </div>
      </div>

      <div className="webdev-cta">
        <h2>Need a Custom Web Solution?</h2>
        <p>Use our AI-powered quotation generator and get started in minutes.</p>
        <button onClick={() => window.open('/project_prompt', '_blank')}>
          Generate Quotation
        </button>
      </div>
    </div>
  );
};

export default WebDevelopment;
